export default __webpack_public_path__ + "static/media/rank3.a8fc8def.png";